var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowUp = function SvgIconArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.462 39.95c0 1.35 1.09 2.44 2.44 2.44s2.44-1.09 2.44-2.44V13.942l7.65 7.46c.98.96 2.58.96 3.56 0s.98-2.52 0-3.48L25.812 6.47s-.09-.1-.14-.14a2.56 2.56 0 0 0-3.56 0l-11.88 11.58c-.98.96-.98 2.52 0 3.48s2.58.96 3.56 0l7.66-7.47v26.03z",
    clipRule: "evenodd"
  })));
};
export default SvgIconArrowUp;